import React from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";

// Simple UUID generator
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
import Link from "../Link/Link";
import s from "./verification-document.css";
import cs from "../../components/commonStyle.css";
import cx from "classnames";
import { Grid, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { checkVerificationStatus } from "../../actions/QRCode/checkVerificationStatus";
import { uploadDocument } from "../../actions/CarDocument/uploadDocument";
import { manageListingSteps } from "../../actions/manageListingSteps";

// Translation
import { injectIntl, FormattedMessage } from "react-intl";

// Locale
import messages from "../../locale/messages";

import DocumentUpload from "../DocumentUpload/DocumentUpload";
import scanIcon from "../../../public/SiteIcons/scanIconWhite.svg";
import arrowRight from "../../../public/SiteIcons/arrow-right-white.svg";
import { Button } from "react-bootstrap/lib/InputGroup";
import ScanQRCodeModal from "../ScanQRCodeModal/ScanQRCodeModal";

import FileIcon from "../../../public/SiteIcons/fileIcon.svg";
import FileIconRed from "../../../public/SiteIcons/fileIconRed.svg";
import verifyCheck from "../../../public/SiteIcons/verifyCheck.svg";
import verifyFailed from "../../../public/SiteIcons/verifyFailed.svg";

import { GoTrash } from "react-icons/go";
import { FaCheckCircle } from "react-icons/fa";

import VerificationSuccess from "../VerificationSuccess/VerificationSuccess";
import VerificationFailedModal from "../VerificationFailedModal/VerificationFailedModal";
import showToaster from "../../helpers/toasterMessages/showToaster";

import { gql } from "react-apollo";
import { graphql } from "react-apollo";
import { getCarDocuments } from "../../actions/getCarDocuments";
import history from "../../core/history";
import DocumentUploadCar from "../DocumentUpload/DocumentUploadCar";



class DocumentVerification extends React.Component {
  static propTypes = {
    previousPage: PropTypes.func,
    nextPage: PropTypes.func,
    formPage: PropTypes.string,
    step: PropTypes.number,
    listId: PropTypes.number,
    checkVerificationStatus: PropTypes.func,
    qrCode: PropTypes.string,
    reference: PropTypes.string,
    url: PropTypes.string,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    errorCode: PropTypes.string,
    status: PropTypes.string,
    userId: PropTypes.string,
    username: PropTypes.string,
    uploadDocument: PropTypes.func,
    manageListingSteps: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const initialQrCodeId = generateUUID();
    const initialCategory = "proof_of_insurance"; // First step category
    const initialDeepLink = `motostream://verify?userId=${props.userId}&listId=${props.listId}&category=${initialCategory}&qrId=${initialQrCodeId}`;

    this.state = {
      qrCodeId: initialQrCodeId,
      deepLink: initialDeepLink,
      showScanQRModal: false,
      isExpired: false,
      isDocuPassLoaded: false,
      showSuccessModal: false,
      showFailedModal: false,
      activeStep: 1,
      completedSteps: [],
      uploadProgress: 0,
      isUploading: false,
      uploadError: null,
      uploadedDocuments: {}, // Store by category
      uploadStates: {
        proof_of_insurance: {},
        proof_of_maintenance_record: {},
        proof_of_ownership: {},
      },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.toggleSuccessModal = this.toggleSuccessModal.bind(this);
    this.toggleFailedModal = this.toggleFailedModal.bind(this);
    this.toggleScanQRModal = this.toggleScanQRModal.bind(this);
    this.refreshUploadedDocument = this.refreshUploadedDocument.bind(this);
  }
  //     }, 15 * 60 * 1000); // 15 minutes

  //     // Start status check when QR code is generated
  //     //  this.startStatusCheck();
  //   }

  //   // Handle status changes
  //   if (this.props.status !== prevProps.status) {
  //     if (this.props.status === "completed") {
  //       this.setState({
  //         showScanQRModal: false,
  //         showSuccessModal: true,
  //       });
  //       // Clear status check interval
  //       if (this.statusCheckInterval) {
  //         clearInterval(this.statusCheckInterval);
  //       }
  //     } else if (this.props.status === "failed") {
  //       this.setState({
  //         showScanQRModal: false,
  //         showFailedModal: true,
  //       });
  //       // Clear status check interval
  //       if (this.statusCheckInterval) {
  //         clearInterval(this.statusCheckInterval);
  //       }
  //     }
  //   }

  //   // Handle DocuPass updates
  //   if (this.props.reference && this.props.reference !== prevProps.reference) {
  //     this.initDocuPass();
  //   }
  // }

  async componentDidMount() {
    const { userId, listId } = this.props;
    console.log('DocumentVerification: componentDidMount userId:', userId, 'listId:', listId);
    if (userId && listId) {
      await this.fetchUploadedDocument();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.activeStep !== this.state.activeStep ||
        prevProps.userId !== this.props.userId ||
        prevProps.listId !== this.props.listId) &&
      this.props.userId && this.props.listId
    ) {
      console.log('DocumentVerification: componentDidUpdate userId:', this.props.userId, 'listId:', this.props.listId);
      await this.fetchUploadedDocument();
    }
  }

  async fetchUploadedDocument() {
    const { userId, listId } = this.props;
    if (!userId || !listId) return;
    try {
      const documents = await this.props.getCarDocuments(userId, listId);
      // Map documents by category for step-wise lookup
      const docMap = {};
      const completedSteps = [];
      const uploadStates = {
        proof_of_insurance: {},
        proof_of_maintenance_record: {},
        proof_of_ownership: {},
      };
      if (Array.isArray(documents)) {
        documents.forEach(doc => {
          if (doc.category) {
            docMap[doc.category] = doc;
            // Map backend category to step number
            let stepNum = null;
            let localCat = null;
            if (doc.category === 'PROOF_OF_INSURANCE' || doc.category === 'proof_of_insurance') {
              stepNum = 1;
              localCat = 'proof_of_insurance';
            } else if (doc.category === 'PROOF_OF_MAINTENANCE' || doc.category === 'proof_of_maintenance_record') {
              stepNum = 2;
              localCat = 'proof_of_maintenance_record';
            } else if (doc.category === 'PROOF_OF_OWNERSHIP' || doc.category === 'proof_of_ownership') {
              stepNum = 3;
              localCat = 'proof_of_ownership';
            }
            if (stepNum && localCat) {
              completedSteps.push(stepNum);
              uploadStates[localCat] = {
                file: { name: doc.uploadFile.split('/').pop() },
                status: 'success',
                progress: 100
              };
            }
          }
        });
      }
      this.setState({ uploadedDocuments: docMap, completedSteps, uploadStates });
    } catch (e) {
      console.error("Error fetching documents:", e);
      // fail silent
    }
  }

  async refreshUploadedDocument() {
    await this.fetchUploadedDocument();
  }

  componentWillUnmount() {
    if (this.expiryTimer) {
      clearTimeout(this.expiryTimer);
    }
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
    }
  }

  handleBack() {
    const { activeStep, completedSteps } = this.state;
    const { listId } = this.props;

    if (activeStep > 1) {
      // Go back to previous document step
      const newQrCodeId = generateUUID();
      const prevCategory = this.getCategoryForStep(activeStep - 1);
      const deepLink = `motostream://verify?userId=${this.props.userId}&listId=${this.props.listId}&category=${prevCategory}&qrId=${newQrCodeId}`;

      this.setState((prevState) => ({
        activeStep: prevState.activeStep - 1,
        qrCodeId: newQrCodeId,
        deepLink: deepLink,
        uploadProgress: 0,
        uploadError: null,
        isUploading: false,
      }));

      // Clear the dropzone
      const dropzoneElements = document.querySelectorAll(".dz-preview");
      dropzoneElements.forEach((el) => el.remove());
    } else if (activeStep === 1) {
      // If on first step, go back to home page for this list
      history.push(`/become-a-owner/${listId}/home`);
    }
  }

  async handleSubmit() {
    const { nextPage, listId, manageListingSteps } = this.props;
    const { completedSteps } = this.state;

    // Only proceed if all 3 documents are uploaded
    if (completedSteps.length === 3) {
      try {
        // Mark step 4 as completed
        await manageListingSteps(listId.toString(), 4);
        // Navigate to home
        nextPage("home");
      } catch (error) {
        showToaster({
          messageId: "Failed to complete verification step",
          toasterType: "error",
        });
      }
    } else {
      showToaster({
        messageId: "Please upload all required documents",
        toasterType: "error",
      });
    }
  }

  toggleSuccessModal() {
    this.setState((prevState) => ({
      showSuccessModal: !prevState.showSuccessModal,
    }));
  }

  toggleFailedModal() {
    this.setState((prevState) => ({
      showFailedModal: !prevState.showFailedModal,
    }));
  }

  toggleScanQRModal() {
    this.setState((prevState) => ({
      showScanQRModal: !prevState.showScanQRModal,
    }));
  }

  // Map step number to category
  getCategoryForStep(stepNumber) {
    const categoryMap = {
      1: "proof_of_insurance",
      2: "proof_of_maintenance_record",
      3: "proof_of_ownership",
    };
    return categoryMap[stepNumber];
  }

  handleFileUpload = async (file) => {
    const { activeStep } = this.state;
    const { userId, listId, uploadDocument } = this.props;
    const category = this.getCategoryForStep(activeStep);
    // Set uploading state
    this.setState((prev) => ({
      uploadStates: {
        ...prev.uploadStates,
        [category]: { status: 'uploading', progress: 0, file }
      }
    }));
    try {
      // Call uploadDocument API (always call, backend should handle insert/update logic)
      const result = await uploadDocument(userId, file, category, listId);
      if (result && result.status === 'success') {
        // Set verifying then success
        this.setState((prev) => ({
          uploadStates: {
            ...prev.uploadStates,
            [category]: { status: 'verifying', progress: 100, file }
          }
        }));
        setTimeout(async () => {
          // Refresh uploaded documents from backend for accuracy
          await this.refreshUploadedDocument();
          this.setState((prev) => ({
            uploadStates: {
              ...prev.uploadStates,
              [category]: { status: 'success', progress: 100, file }
            },
            completedSteps: [...new Set([...prev.completedSteps, activeStep])],
          }));
        }, 1000);
      } else {
        // Error state
        this.setState((prev) => ({
          uploadStates: {
            ...prev.uploadStates,
            [category]: { status: 'error', progress: 0, file }
          }
        }));
      }
    } catch (e) {
      // Error state
      this.setState((prev) => ({
        uploadStates: {
          ...prev.uploadStates,
          [category]: { status: 'error', progress: 0, file }
        }
      }));
    }
  };

  handleDelete = () => {
    const { activeStep } = this.state;
    const category = this.getCategoryForStep(activeStep);
    this.setState((prev) => ({
      uploadStates: {
        ...prev.uploadStates,
        [category]: {}
      },
      completedSteps: prev.completedSteps.filter((step) => step !== activeStep),
    }));
  };

  handleRetry = () => {
    const { activeStep, uploadStates } = this.state;
    const category = this.getCategoryForStep(activeStep);
    const file = uploadStates[category]?.file;
    if (file) this.handleFileUpload(file);
  };


  handleNextStep() {
    const { activeStep } = this.state;
    const { userId, listId } = this.props;

    if (activeStep < 3) {
      // Generate new QR code for next step
      const newQrCodeId = generateUUID();
      const nextCategory = this.getCategoryForStep(activeStep + 1);
      const deepLink = `motostream://verify?userId=${userId}&listId=${listId}&category=${nextCategory}&qrId=${newQrCodeId}`;
      this.setState((prevState) => ({
        activeStep: prevState.activeStep + 1,
        uploadProgress: 0,
        uploadError: null,
        qrCodeId: newQrCodeId,
        deepLink: deepLink,
        isExpired: false, // Reset expiry when moving to next step,
        uploadProgress: 0,
        uploadError: null,
        isUploading: false,
      }));

      // Clear the dropzone for the previous step
      const dropzoneElements = document.querySelectorAll(".dz-preview");
      dropzoneElements.forEach((el) => el.remove());
    } else if (activeStep === 3 && this.state.completedSteps.length === 3) {
      // All documents uploaded, mark step 4 as completed
      this.props.nextPage("home");
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { qrCode, reference, url, isLoading, error, errorCode } = this.props;
    const {
      showScanQRModal,
      isExpired,
      showSuccessModal,
      showFailedModal,
      activeStep,
      completedSteps,
      uploadProgress,
      isUploading,
      uploadError,
    } = this.state;

    // Handle API error message
    const errorMessage =
      error || "An error occurred while generating the QR code";

    const steps = [
      { num: 1, text: formatMessage(messages.documentStepProofOfInsurance) },
      { num: 2, text: formatMessage(messages.documentStepProofOfMaintenance) },
      { num: 3, text: formatMessage(messages.documentStepProofOfOwnership) },
    ];
    const { uploadedDocuments } = this.state;
    // Map step to category string for lookup
    const categoryMap = {
      1: "proof_of_insurance",
      2: "proof_of_maintenance_record",
      3: "proof_of_ownership",
    };
    const currentCategory = categoryMap[activeStep];
    // Pass only the relevant file for the current step
    const currentStepFile = uploadedDocuments && uploadedDocuments[currentCategory] ? [uploadedDocuments[currentCategory]] : [];

    return (
      <Grid fluid className={"listingContainer"}>
        <Row>
          {/* <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
            <DashboardSideMenu isTrustVerfiedPage />
          </Col> */}
          <Col xs={12} sm={12} md={12} lg={12} className={cs.spaceTop6}>
            <div className={cx("youcarsBg", "documentDropCss")}>
              <div className={s.documentVerificationContainer}>
                <div
                  className={cx(
                    s.documentVerificationHeader,
                    cs.textAlignCenter
                  )}
                >
                  <h3 className={cx(s.infoTitle, cs.fontDMSerif)}>
                    {formatMessage(messages.documentVerificationTitle)}
                  </h3>
                  <p className={cx(s.infoText, cs.fontDMSans)}>
                    {formatMessage(messages.documentVerificationInfoText)}
                  </p>
                </div>
                <div className={s.documentStepList}>
                  {steps.map((step) => (
                    <div
                      key={step.num}
                      className={cx(
                        s.documentStep,
                        { [s.active]: step.num <= activeStep },
                        { [s.completed]: completedSteps.includes(step.num) }
                      )}
                    >
                      <div className={s.documentStepNum}>
                        {completedSteps.includes(step.num) ? "✓" : step.num}
                      </div>
                      <div className={s.documentStepText}>{step.text}</div>
                    </div>
                  ))}
                </div>
                 {/* Step-wise file upload UI - always show dropzone */}
                 {(() => {
                   const uploadState = this.state.uploadStates[currentCategory] || {};
                   const { file, status, progress } = uploadState;
                   const backendDoc = this.state.uploadedDocuments[currentCategory];
                   console.log("file", file);
                   return (
                     <>
                       <DocumentUploadCar
                         key={`document-upload-${activeStep}`}
                         placeholder={formatMessage(messages.documentUploadPlaceholder)}
                         onUpload={this.handleFileUpload}
                         isUploading={status === 'uploading'}
                         uploadProgress={progress || 0}
                         error={uploadError}
                         category={this.getCategoryForStep(activeStep)}
                         uploadedDocument={[]}
                         refreshUploadedDocument={this.refreshUploadedDocument}
                       />
                       {/* Show row for new upload (in progress or just uploaded) */}
                       {file && (
                         <div className={cx(s.fileUploadContainer, cs.spaceTop4)}>
                           <div className={s.fileUploadHeader}>
                             <div className={s.fileUploadIcon}><img src={FileIcon} alt="File Upload" /></div>
                             <div className={s.fileUploadcontent}>
                               <h3 className={s.fileUploadTitle}>{file.name || (file && file.file && file.file.name) || 'File Uploaded'}</h3>
                               <p className={s.fileUploadText}>{file.size ? (file.size/1024).toFixed(0) + " KB" : ""}</p>
                             </div>
                             {status === 'success' ? (
                               <div className={s.deleteIcon}><FaCheckCircle className={s.checkIcon} /></div>
                             ) : (
                               <button className={cx(s.deleteIcon, cs.btn)} onClick={this.handleDelete}><GoTrash /></button>
                             )}
                           </div>
                           <div className={s.fileUploadProgress}>
                             <div className={s.fileUploadProgressBar}>
                               <div className={cx({
                                 [s.fileUploadProgressFill]: status === 'uploading' || status === 'verifying',
                                 [s.fileUploadProgressFillSuccess]: status === 'success'
                               })} style={{width: `${progress || 0}%`}}></div>
                             </div>
                             <div className={s.fileUploadProgressText}>{progress || 0}%</div>
                           </div>
                           {status === 'verifying' && (
                             <div className={s.verifyStatusContainer}>
                               <div className={s.loader}></div>
                               <div className={cx(s.verifyStatusText, s.italic)}>Uploading...</div>
                             </div>
                           )}
                           {status === 'success' && (
                             <div className={s.verifyStatusContainer}>
                               <div className={s.verifyStatusIcon}><img src={verifyCheck} alt="Verified" /></div>
                               <div className={cx(s.verifyStatusText)}>Uploaded Successfully</div>
                             </div>
                           )}
                           {status === 'error' && (
                             <div className={s.verifyStatusContainer}>
                               <div className={s.verifyStatusIcon}><img src={verifyFailed} alt="Verified" /></div>
                               <div className={cx(s.verifyStatusText, s.failed)}>Uploaded Failed</div>
                               <button className={cx(s.verifyStatusBtn, cs.btn)} onClick={this.handleRetry}>Try Again</button>
                             </div>
                           )}
                         </div>
                       )}
                       {/* If no upload in progress, but backend doc exists, show backend doc row */}
                       {!file && backendDoc && backendDoc.uploadFile && (
                         <div className={cx(s.fileUploadContainer, cs.spaceTop4)}>
                           <div className={s.fileUploadHeader}>
                             <div className={s.fileUploadIcon}><img src={FileIcon} alt="File Upload" /></div>
                             <div className={s.fileUploadcontent}>
                               <h3 className={s.fileUploadTitle}>{backendDoc.uploadFile.split('/').pop()}</h3>
                             </div>
                             <div className={s.deleteIcon}><FaCheckCircle className={s.checkIcon} /></div>
                           </div>
                           <div className={s.fileUploadProgress}>
                             <div className={s.fileUploadProgressBar}>
                               <div className={s.fileUploadProgressFillSuccess} style={{width: "100%"}}></div>
                             </div>
                             <div className={s.fileUploadProgressText}>100%</div>
                           </div>
                           <div className={s.verifyStatusContainer}>
                             <div className={s.verifyStatusIcon}><img src={verifyCheck} alt="Verified" /></div>
                             <div className={cx(s.verifyStatusText)}>Uploaded Successfully</div>
                           </div>
                         </div>
                       )}
                     </>
                   );
                 })()}

                {/* Show error message if there's an error */}
                {error && (
                  <div className={s.errorContainer}>
                    <div className={s.errorMessage}>
                      {errorMessage}
                      {errorCode === "402" && (
                        <p className={s.errorHint}>
                          {formatMessage(messages.documentQuotaLimitSupportHint)}
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* DocuPass iframe */}
                {/* <div className={s.docupassContainer}>
                  {url && !error && (
                    <iframe
                      src={url}
                      className={s.docupassIframe}
                      frameBorder="0"
                      allowFullScreen
                    />
                  )}
                </div> */}

                <div className={s.qrcodeContainer}>
                  <h3 className={s.qrcodeTitle}>{formatMessage(messages.documentAlternativeMethodsTitle)}</h3>
                  <p className={s.qrcodeText}>
                    {formatMessage(messages.documentQRCodeInstruction)}
                  </p>

                  <Link
                    to="#"
                    onClick={this.toggleScanQRModal}
                    className={s.scanCodeBtn}
                  >
                    <img src={scanIcon} alt="QR Code" /> {formatMessage(messages.documentScanQRCodeBtn)}
                  </Link>
                </div>
                <div className={s.bottomBtnContainer}>
                  <button
                    type="button"
                    onClick={this.handleBack}
                    className={cx(cs.btn, s.bottomBtn, s.active)}
                  >
                    {formatMessage(messages.documentBackBtn)}
                  </button>
                  {activeStep < 3 ? (
                    <button
                      type="button"
                      onClick={this.handleNextStep}
                      className={cx(cs.btn, s.bottomBtn, s.active)}
                      disabled={!(this.state.uploadStates[currentCategory]?.status === 'success')}
                    >
                      {formatMessage(messages.documentNextStepBtn)} <img src={arrowRight} alt="Arrow Right" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={this.handleSubmit}
                      className={cx(cs.btn, s.bottomBtn, s.active)}
                      disabled={!completedSteps.includes(3)}
                    >
                      {formatMessage(messages.documentFinishBtn)} <img src={arrowRight} alt="Arrow Right" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <ScanQRCodeModal
          onClose={this.toggleScanQRModal}
          show={showScanQRModal}
          qrCode={this.state.deepLink}
          verificationLink={this.state.deepLink}
          isExpired={isExpired}
          onRegenerateQR={() => {
            const newQrCodeId = generateUUID();
            const category = this.getCategoryForStep(activeStep);
            const deepLink = `motostream://verify?userId=${this.props.userId}&listId=${this.props.listId}&category=${category}&qrId=${newQrCodeId}`;
            this.setState({ qrCodeId: newQrCodeId, deepLink });
          }}
          isLoading={isLoading}
          error={error}
          errorCode={errorCode}
        />

        {/* Verification Success Modal */}
      </Grid>
    );
  }
}

const mapState = (state) => ({
  qrCode: state.qrcode.qrData,
  reference: state.qrcode.reference,
  url: state.qrcode.url,
  isLoading: state.qrcode.isLoading,
  error: state.qrcode.error,
  errorCode: state.qrcode.errorCode,
  status: state.qrcode.status,
  userId: state.account.data.userId,
  username: state.account.data.firstName + " " + state.account.data.lastName,
});

const mapDispatch = {
  uploadDocument,
  manageListingSteps,
  getCarDocuments,
};

export default connect(
  mapState,
  mapDispatch
)(withStyles(s, cs)(injectIntl(DocumentVerification)));
